export default __webpack_public_path__ + "static/faunus-issues-4ff24ccf7dd95928af56650a93ac8d0e.jpg";